import { render, staticRenderFns } from "./ModalEditAccountRights.vue?vue&type=template&id=641ac826"
import script from "./ModalEditAccountRights.vue?vue&type=script&lang=js"
export * from "./ModalEditAccountRights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports